import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import RecruitNav from './Components/RecruitNav';
import data from './data/recruit.json';
import wage from './data/wage.json';
import GlobalHeader from './Components/GlobalHeader';
import GlobalFooter from './Components/GlobalFooter';
import ScrollToTopButton from './Components/ScrollToTopButton';

const Home = lazy(() => import('./Pages/Home'));
const Mid = lazy(() => import('./Pages/Mid/Mid'));
const MidDetail = lazy(() => import('./Pages/Mid/MidDetail'));
const Tokusyu = lazy(() => import('./Pages/Tokusyu/Tokusyu'));
const NoMatch = lazy(() => import('./Components/NoMatch'));

const locations = Object.keys(data.em);

const App = () => {
 return (
    <>
		<GlobalHeader />
		<div className='wrap'>
			<RecruitNav />
			<div className="content">
			<Suspense fallback={<div className='container'><div className='lazyload'>
				<div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
				</div></div>}>
				<Routes>
					<Route path="/" element={<Home wage={wage}/>} />
					<Route path="/tokusyu/:location" element={<Tokusyu/>} />
					{locations.map((location) => (
					<Route
						key={location}
						path={`/${location}`}
						element={<Mid location={location} data={data} wage={wage} />}>		
					</Route>
					))}
					<Route path="/:location/:slug" element={<MidDetail data={data} wage={wage} />}/>
					<Route path="*" element={<NoMatch />} />
				</Routes>
			</Suspense>
			</div>
			<ScrollToTopButton />
		</div>
		<GlobalFooter />
    </>
 );
};

export default App;